export default [
  {
    title: '规则ID',
    key: 'ruleId',
    type: 'basic',
    fixed: true,
    width: 60
  },
  {
    title: '游戏组',
    key: 'gameGroupName',
    type: 'basic',
    fixed: true,
    width: 108
  },
  {
    title: '媒体',
    key: 'mediaName',
    type: 'basic',
    fixed: true
  },
  {
    title: '规则',
    key: 'planCount',
    type: 'basic',
    fixed: true
  },
  {
    title: '操作',
    key: 'control',
    type: 'basic',
    fixed: true,
    width: 40
  }
]
